import FacultyStaffIndex from './components/FacultyStaffUsers/IndexComponent';
import HousingUserIndex from './components/HousingUsers/IndexComponent';
import PermitSalesReport from './components/PermitSalesReport/IndexComponent';
import PayrollReport from './components/PayrollReport/IndexComponent';
import UserLookup from './components/UserLookup/IndexComponent';
import HousingMove from './components/HousingMove/IndexComponent';
import PermitRates from './components/PermitRates/IndexComponent';
import ExpirePermit from './components/ExpirePermit/IndexComponent';
import ReservePermit from './components/ReservePermit/IndexComponent';
import LostHangTag from './components/LostHangTag/IndexComponent';
import NewAYPermits from './components/NewAYPermits/IndexComponent';
import NonTypicalEntry from './components/NonTypicalEntry/IndexComponent';
import TicketViolationType from './components/TicketViolationType/IndexComponent';
import LateTicketEntry from './components/LateTicket/IndexComponent';
import TicketIssued from './components/TicketIssued/IndexComponent';


export default {
    mode: "history",
    base: '/' + process.env.MIX_APP_NAME + '/',
    routes: [
        {
            path: "/admin/facultystaffusers",
            component: FacultyStaffIndex,
            name: "FacultyStaffIndex"
        },
        {
            path: "/admin/housingusers",
            component: HousingUserIndex,
            name: "HousingUserIndex"
        },
        {
            path: "/admin/permitsalesreport",
            component: PermitSalesReport,
            name: "PermitSalesReport"
        },
        {
            path: "/admin/payrollreport",
            component: PayrollReport,
            name: "PayrollReport"
        },
        {
            path: "/admin/userlookup",
            component: UserLookup,
            name: "UserLookup"
        },
        {
            path: "/admin/housingmove",
            component: HousingMove,
            name: "HousingMove"
        },
        {
            path: "/admin/permitrates",
            component: PermitRates,
            name: "PermitRates"
        },
        {
            path: "/admin/expirepermit",
            component: ExpirePermit,
            name: "ExpirePermit"
        },
        {
            path: "/admin/reservepermit",
            component: ReservePermit,
            name: "ReservePermit"
        },
        {
            path: "/admin/losthangtag",
            component: LostHangTag,
            name: "LostHangTag"
        },
        {
            path: "/admin/newaypermits",
            component: NewAYPermits,
            name: "NewAYPermits"
        },
        {
            path: "/admin/nontypicalentry",
            component: NonTypicalEntry,
            name: "NonTypicalEntry"
        },
        {
            path: "/admin/violationtickettype",
            component: TicketViolationType,
            name: "TicketViolationType"
        },
        {
            path: "/admin/lateticketentry",
            component: LateTicketEntry,
            name: "LateTicketEntry"
        },
        {
            path: "/admin/ticketissued",
            component: TicketIssued,
            name: "TicketIssued"
        },
    ]
}
